// Node Modules Imports
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Draggable from 'react-draggable';


// Material-UI Imports
import { Button } from '@material-ui/core/';
import CloseIcon from '@material-ui/icons/Close';
import MinimizeIcon from '@material-ui/icons/Minimize';
import MaximizeIcon from '@material-ui/icons/Maximize';
import CircularProgress from '@material-ui/core/CircularProgress';

// My Components Imports
import { ContentContainer, Header, StyledTypography, StyledPaper, Details, StyledIconButton, FieldsContainer, ActionsContainer } from './styles';
import ReceiverInput from './ReceiverInput/';
import NotificationPreview from './NotificationPreview/';
import Input from './../Input/Input';

// Axios
import axios from '../../config/axiosInstance';

// Actions Imports
import { fetchEmployees } from '../../store/actions/employee';
import { setMessage } from '../../store/actions/general';

function getUnique(myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}


const NotificationFloatingBox = ({ onClose }) => {
  const dispatch = useDispatch();
  const userName = useSelector(state => state.auth.userName);
  const [state, setState] = React.useState({
    employees: [],
    message: '',
    receivers: null,
    employeeList: [],
    minimized: false,
    loading: false,
  });

  const getEmployess = () => {
    dispatch(fetchEmployees())
      .then((result) => {
        const departaments = getUnique(result, 'departmentId').map(employee => ({
          value: `${employee.departmentId}${employee._department}`,
          label: employee._department,
          isDepartment: true,
          id: employee.departmentId,
        }));

        const employees = result.map(employee => ({
          value: `${employee.id}${employee.name}`,
          label: employee.name,
          isDepartment: false,
          id: employee.id,
        }));
        setState({ ...state, employeeList: result, employees: employees.concat(departaments) });
      });
  };

  React.useEffect(getEmployess, []);

  const sendNotification = () => {
    setState({ ...state, loading: true });
    const receivers = () => {
      const sendToAll = state.receivers.filter(r => r.value === 'todos').length > 0;
      if (sendToAll) {
        return state.employeeList.map(employee => employee.id);
      }

      let departamentsEmployees = [];
      const selectedEmployees = state.receivers.filter(d => !d.isDepartment);
      const selectedDepartments = state.receivers.filter(d => d.isDepartment);
      selectedDepartments.forEach((departament) => {
        departamentsEmployees = departamentsEmployees
          .concat(state.employeeList.filter(employee => employee.departmentId === departament.id));
      });

      return selectedEmployees
        .concat(departamentsEmployees)
        .map(employee => employee.id);
    };

    const notification = {
      recipients: receivers(),
      message: state.message,
      title: `${userName} diz:`,
    };

    axios.post('/pushNotificationsMessage', notification)
      .then(() => {
        setState({ ...state, loading: false });
        onClose();
        dispatch(setMessage('Notificação enviada com sucesso!'));
      })
      .catch(() => {
        setState({ ...state, loading: false });
        dispatch(setMessage('Ocorreu um erro durante a operação. Tente novamente.'));
      });
  };

  return (
    <Draggable
      axis="x"
      handle=".handle"
      bounds="main"
    >
      <StyledPaper minimized={state.minimized}>
        <Header className="handle">
          <StyledTypography variant="body2">
            Nova notificação
            <Details> (beta)</Details>
          </StyledTypography>
          <StyledIconButton onClick={() => setState({ ...state, minimized: !state.minimized })}>
            {!state.minimized ? <MinimizeIcon /> : <MaximizeIcon />}
          </StyledIconButton>
          <StyledIconButton onClick={onClose} >
            <CloseIcon />
          </StyledIconButton>
        </Header>

        <ContentContainer minimized={state.minimized}>
          <FieldsContainer>
            <ReceiverInput
              data={state.employees}
              onValueChange={(receivers => setState({ ...state, receivers }))}
            />

            <Input
              elementType="input"
              fullWidth
              label="Mensagem"
              margin="normal"
              placeholder="Digite sua mensagem aqui"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event => setState({ ...state, message: event.target.value }))}
            />

            <NotificationPreview author={userName} message={state.message} />
          </FieldsContainer>

          <ActionsContainer>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              disabled={(
                !state.message || (state.message && state.message.length === 0) || (
                  state.receivers === null || (state.receivers && state.receivers.length === 0)
                ) || state.loading
              )}
              onClick={sendNotification}
            >
              { state.loading ? <CircularProgress size={20} /> : 'ENVIAR' }
            </Button>
          </ActionsContainer>
        </ContentContainer>
      </StyledPaper>
    </Draggable>
  );
};

export default NotificationFloatingBox;
